import { z } from "zod/v4";

export const announcementSchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	author_id: z.string().uuid(),
	author_name: z.string(),
	author_avatar_url: z.string().nullable().optional(),
	content: z.string(),
	created_at: z.coerce.date(),
});

export const createAnnouncementSchema = z.object({
	content: z.string().min(1, "Content is required"),
	send_push: z.boolean().default(false),
	target_type: z
		.enum(["all", "member_type", "membership_type", "skill_level", "specific"])
		.default("all"),
	target_member_type: z.string().nullable().optional(),
	target_membership_type: z.string().nullable().optional(),
	target_skill_level: z.string().nullable().optional(),
	target_user_ids: z.array(z.string().uuid()).nullable().optional(),
});

export type CreateAnnouncementPayload = z.infer<typeof createAnnouncementSchema>;
